import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AuditActionsFetchFailedAction = {
	type: 'AUDIT_ACTIONS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AuditActionsFetchFailedAction => ({
	type: 'AUDIT_ACTIONS_FETCH_FAILED',
	payload,
});
